import { render, staticRenderFns } from "./InstitutionServicesItems.vue?vue&type=template&id=d0de054c&scoped=true&"
import script from "./InstitutionServicesItems.vue?vue&type=script&lang=js&"
export * from "./InstitutionServicesItems.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d0de054c",
  null
  
)

export default component.exports